package com.macrofocus.eflux

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.common.selection.Selection
import com.macrofocus.common.selection.SingleSelection
import com.macrofocus.eflux.network.coordinate.Coordinate
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.risk.RiskComponent
import com.macrofocus.eflux.network.schema.Schema

interface EFluxController {
    val logicalBusProbing: SingleSelection<LogicalBusId>
    val logicalBranchProbing: SingleSelection<LogicalBranchId>
    val riskComponentProbing: SingleSelection<RiskComponent>
    val coordinateProbing: SingleSelection<Coordinate>
    val schemaProbing: SingleSelection<Schema>

    val logicalBusSelection: Selection<LogicalBusId>
    val logicalBranchSelection: Selection<LogicalBranchId>
    val riskComponentSelection: Selection<RiskComponent>
    val coordinateSelection: Selection<Coordinate>
    val schemaSelection: Selection<Schema>

    val primaryLogicalBusProbing: MutableSingleSelection<LogicalBusId>
    val primaryLogicalBranchProbing: MutableSingleSelection<LogicalBranchId>
    val primaryRiskComponentProbing: MutableSingleSelection<RiskComponent>
    val primaryCoordinateProbing: MutableSingleSelection<Coordinate>
    val primarySchemaProbing: MutableSingleSelection<Schema>

    val primaryLogicalBusSelection: MutableSelection<LogicalBusId>
    val primaryLogicalBranchSelection: MutableSelection<LogicalBranchId>
    val primaryRiskComponentSelection: MutableSelection<RiskComponent>
    val primaryCoordinateSelection: MutableSelection<Coordinate>
    val primarySchemaSelection: MutableSelection<Schema>

    val secondaryLogicalBusProbing: MutableSingleSelection<LogicalBusId>
    val secondaryLogicalBranchProbing: MutableSingleSelection<LogicalBranchId>
    val secondaryRiskComponentProbing: MutableSingleSelection<RiskComponent>
    val secondaryCoordinateProbing: MutableSingleSelection<Coordinate>
    val secondarySchemaProbing: MutableSingleSelection<Schema>

    val secondaryLogicalBusSelection: MutableSelection<LogicalBusId>
    val secondaryLogicalBranchSelection: MutableSelection<LogicalBranchId>
    val secondaryRiskComponentSelection: MutableSelection<RiskComponent>
    val secondaryCoordinateSelection: MutableSelection<Coordinate>
    val secondarySchemaSelection: MutableSelection<Schema>

    val primaryProbing: MutableSingleSelection<Any>
    val primarySelection: MutableSingleSelection<Any>

    val secondaryProbing: MutableSingleSelection<Any>
    val secondarySelection: MutableSingleSelection<Any>

    val secondary: MutableProperty<Boolean>

    fun top(probed: Any?, selected: Any?): Any?

    fun extra(probed: Any?, selected: Any?): Any?

    val overlayProbing: Boolean

    fun probeSubstation(logicalBusId: LogicalBusId?, primary: Boolean = true)

    fun probeLine(logicalBranchId: LogicalBranchId?, primary: Boolean = true)

    fun probeCoordinate(coordinate: Coordinate?, primary: Boolean = true)

    fun selectSubstation(logicalBusId: LogicalBusId?, primary: Boolean = true)

    fun selectLine(logicalBranchId: LogicalBranchId?, primary: Boolean = true)

    fun selectCoordinate(coordinate: Coordinate?, primary: Boolean = true)
}
